import React from 'react';

import { AroIdMeVerificationPage } from './pages/AroIdMeVerification';
import AuthCallbackPage from './pages/Auth/Login';
import { MobileSessionTransitionPage } from './pages/Auth/MobileSessionTransition';
import AuthPartnerLinkPage from './pages/Auth/PartnerLink';
import { ChangePassword } from './pages/ChangePassword';
import { ForgotPassword } from './pages/ForgotPassword';
import { ContactSupport } from './pages/MFA/ContactSupport';
import { EmailVerificationPage } from './pages/MFA/EmailVerificationPage';
import { EmailVerificationSignin } from './pages/MFA/EmailVerificationSignin';
import { MFAEnrollmentPage } from './pages/MFA/Enrollment';
import { PasskeyEnrollmentPage } from './pages/MFA/PasskeyEnrollmentPage';
import { EnterPhoneNumber } from './pages/MFA/SMSEnrollmentPage';
import { SMSVerificationPage } from './pages/MFA/SMSVerificationPage';
import { SMSVerificationSignin } from './pages/MFA/SMSVerificationSignin';
import MarriottBonvoyAuthorizePage from './pages/MarriottBonvoyAuthorize';
import MarriottBonvoyLinkPage from './pages/MarriottBonvoyLink';
import { MlifeActivationWrapper } from './pages/MlifeActivation';
import { ResetPassword } from './pages/ResetPassword';
import { SignIn } from './pages/SignIn';
import { SignInOrJoin } from './pages/SignInOrJoin';
import { SignUp } from './pages/SignUp';
import { IDENTITY_WIDGET_PATHS } from './utils/constants';

export const routes = {
  /** Regular Flows */
  [IDENTITY_WIDGET_PATHS.SignInOrJoin]: () => <SignInOrJoin />,
  [IDENTITY_WIDGET_PATHS.SignIn]: () => <SignIn />,
  [IDENTITY_WIDGET_PATHS.SignInAuthSelection]: () => <SignIn type='auth-selection' />,
  [IDENTITY_WIDGET_PATHS.SignUp]: () => <SignUp />,
  [IDENTITY_WIDGET_PATHS.ForgotPassword]: () => <ForgotPassword />,
  [IDENTITY_WIDGET_PATHS.ResetPassword]: ({ token }: { token?: string }) => <ResetPassword token={token} />,
  [IDENTITY_WIDGET_PATHS.ChangePassword]: () => <ChangePassword />,
  [IDENTITY_WIDGET_PATHS.MlifeActivation]: () => <MlifeActivationWrapper />,
  [IDENTITY_WIDGET_PATHS.AroIdMeVerification]: () => <AroIdMeVerificationPage />,

  /** Session/Token Exchange Flows */
  [IDENTITY_WIDGET_PATHS.OktaRedirect]: () => <AuthCallbackPage />,
  [IDENTITY_WIDGET_PATHS.AuthMobile]: () => <MobileSessionTransitionPage />,

  /** Partner Link Flows */
  [IDENTITY_WIDGET_PATHS.PartnerLink]: () => <AuthPartnerLinkPage />,
  [IDENTITY_WIDGET_PATHS.MarriottBonvoyAuthorize]: () => <MarriottBonvoyAuthorizePage />,
  [IDENTITY_WIDGET_PATHS.MarriottBonvoyPartnerLink]: () => <MarriottBonvoyLinkPage />,

  /** MFA Flows */
  [IDENTITY_WIDGET_PATHS.MfaEnroll]: () => <MFAEnrollmentPage />,
  [IDENTITY_WIDGET_PATHS.MfaEnrollEmail]: () => <EmailVerificationPage type='enrollment' />,
  [IDENTITY_WIDGET_PATHS.MfaEnrollSms]: () => <EnterPhoneNumber />,
  [IDENTITY_WIDGET_PATHS.MfaEnrollSmsVerify]: () => <SMSVerificationPage type='enrollment' />,
  [IDENTITY_WIDGET_PATHS.MfaEnrollPasskey]: () => <PasskeyEnrollmentPage />,
  [IDENTITY_WIDGET_PATHS.MfaAuthSms]: () => <SMSVerificationSignin type='authentication' />,
  [IDENTITY_WIDGET_PATHS.MfaAuthEmail]: () => <EmailVerificationSignin type='authentication' />,
  [IDENTITY_WIDGET_PATHS.MfaContactSupport]: () => <ContactSupport />,
};
